import axios from 'axios';
import { getAtozasLogoutUrl } from '../config/api';

/** Best-effort ATOZAS session destroy. No-op when SSO is disabled or the request fails. */
export const logoutAtozasSession = () => {
  try {
    sessionStorage.removeItem('atozas_silent_sso');
  } catch {
    // ignore
  }
  return axios.post(getAtozasLogoutUrl(), {}, { withCredentials: true }).catch(() => {});
};
